import React, { useState, useEffect } from 'react';
import { Box, Button, CircularProgress, Grid, Link, Typography } from '@mui/material';
import { User } from 'src/interfaces/iuser';
import DataExportForm from './Components/DataExportForm';
import ExportMonitor from './Components/ExportMonitor';
import amazonS3 from 'src/App/assets/amazon-s3.svg';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';

const CustomDataExport = ({ user, getUserInfo }: { user: User; getUserInfo: any }) => {
  const [pageLoading, isPageLoading] = useState(true);

  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    if (user.email !== 'Trial') {
      isPageLoading(false);
    }
  }, [user]);

  if (pageLoading) {
    return (
      <Grid
        xs={12}
        container
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', height: '100%', minHeight: '98vh' }}
      >
        <CircularProgress />
      </Grid>
    );
  }

  if (user.role !== 'admin') {
    return (
      <Grid
        xs={12}
        container
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', height: '100%', minHeight: '98vh' }}
      >
        <Typography variant="h4">You are not authorized to view this page</Typography>
      </Grid>
    );
  }

  return (
    <Grid
      container
      item
      xs={12}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Grid item xs={6}>
        <DataExportForm />
      </Grid>

      <Grid item xs={6}>
        <ExportMonitor />

        <Box sx={{ paddingLeft: 3 }}>
          <Button
            variant="outlined"
            sx={{
              padding: '8px 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderWidth: 2,
              borderColor: COLOR_PRIMARY_2,
              borderRadius: 100,
            }}
          >
            <Link
              href="https://us-east-2.console.aws.amazon.com/s3/buckets/enterprise-custom-data?region=us-east-2&bucketType=general&tab=objects"
              target="_blank"
              underline="none"
              sx={{
                display: 'flex',
                alignItems: 'center',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              <img src={amazonS3} alt="s3 svg" style={{ width: 40, height: 40, marginRight: 8 }} />
              <Typography sx={{ textAlign: 'center', color: COLOR_PRIMARY_2, fontWeight: 'bold' }}>
                Go to S3 Data Storage
              </Typography>
            </Link>
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default CustomDataExport;
